import { memo } from 'react';
import { Handle, Position, NodeProps } from '@xyflow/react';
import { Bell } from 'lucide-react';

function WaitEventNode({ data, selected }: NodeProps) {
  const config = (data.config as Record<string, unknown>) ?? {};
  const eventType = (config.eventType as string) ?? '';
  const timeoutSeconds = (config.timeoutSeconds as number) ?? 0;

  return (
    <div
      className={`w-52 rounded-xl bg-white shadow-sm border border-zinc-200 border-l-4 border-l-amber-400 ${
        selected ? 'ring-2 ring-emerald-400' : ''
      }`}
    >
      <Handle type="target" position={Position.Top} className="!bg-amber-400" />
      <div className="flex items-center gap-2 px-3 py-2 border-b border-zinc-100">
        <Bell size={14} className="text-amber-400 shrink-0" />
        <span className="text-xs font-semibold text-zinc-700 uppercase tracking-wide">
          Wait for Event
        </span>
      </div>
      <div className="px-3 py-2">
        <p className="text-xs text-zinc-500">Event</p>
        <p className="text-xs text-zinc-800 font-medium truncate">
          {eventType || <span className="italic text-zinc-400">Not set</span>}
        </p>
        {timeoutSeconds > 0 && (
          <p className="text-xs text-zinc-400 mt-0.5">Timeout: {timeoutSeconds}s</p>
        )}
      </div>
      {/* Event received — bottom (default / happy path) */}
      <Handle type="source" position={Position.Bottom} id="default" className="!bg-amber-400" />
      {/* Timeout — right side */}
      <Handle
        type="source"
        position={Position.Right}
        id="timeout"
        className="!bg-zinc-400"
        style={{ top: '50%' }}
      />
      {/* Small label so users know which handle is the timeout */}
      <div
        className="absolute text-[9px] text-zinc-400 leading-none pointer-events-none"
        style={{ right: '-38px', top: 'calc(50% - 5px)' }}
      >
        timeout
      </div>
    </div>
  );
}

export default memo(WaitEventNode);
